import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import './ForgotPassword.css';
import { sendAsyncRequest } from '../../services/AsyncRequestService';

import logo from "../../assets/images/RM Logo=Reversed.png";

import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [redirect, setRedirect] = useState(false);

  const handleChange = e => {
    const value = e.target.value;
    setEmail(value);
    setError("");
  }

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    sendAsyncRequest("/forgot-password", "POST", { email: email }, onForgotPasswordSuccess, onForgotPasswordFailure);
  }

  const onForgotPasswordSuccess = (response) => {
    setSuccess("An email has been sent with instructions to reset your password.");
    setRedirect(true);
  }

  const onForgotPasswordFailure = (error) => {
    setError("An error occurred. Please try again.");
  }

  if (redirect) {
    return (
      <Navigate
        to="/reset-password"
        replace
        state={{ email }}
      />
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="login-page">
              <Card className="login-card">
                <Card.Body>
                  <div className="logo-large">
                    <img src={logo} alt="Imagine RazorMetrics Logo" style={{ maxWidth: '200px' }} />
                  </div>
                  <h3 className="login-title">Forgot Password</h3>
                  {error && <Alert variant="danger">{error}</Alert>}
                  {success && <Alert variant="success">{success}</Alert>}
                  <Form onSubmit={handleForgotPassword}>
                    <Form.Group className="form-group">
                      <div className="input-group">
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                        <Form.Control
                          type="email"
                          name="email"
                          value={email}
                          placeholder="Enter your email"
                          onChange={handleChange}
                          className="form-control-with-icon"
                          required
                        />
                      </div>
                    </Form.Group>
                    <Button type="submit" variant="primary" className="login-button">
                      Submit
                    </Button>
                    <div className="text-center" style={{ marginTop: '20px' }}>
                      <Link to="/login">Back to Login</Link>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
      </div>
    </div>
  );
}

export default ForgotPassword;
